import { render, staticRenderFns } from "./ANxERxRelevantEventsPage.vue?vue&type=template&id=74b1587c"
import script from "./ANxERxRelevantEventsPage.vue?vue&type=script&lang=js"
export * from "./ANxERxRelevantEventsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports